import type {ID} from '../../../../utils/utility-types';
import type {MembershipModel} from '../../../domain/Membership/Membership.model';

export abstract class FetchMembershipListQuery {
  abstract exec(
    props: FetchMembershipListQuery.Props,
  ): Promise<MembershipModel[]>;
}

export namespace FetchMembershipListQuery {
  export type Props = {
    courseId: ID;
    excludedStatuses?: MembershipModel.Status[];
    userId?: ID;
  };
}
